<template>
  <div style="width: 100%;height: 60px;background-color: #fff;border-bottom: 1px solid #F2F6FC;margin: 0;">

  </div>
</template>

<script>
export default {
  name: 'Header'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Header.vue